import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import FileSection from './formSections/file';
import { useTranslation } from 'react-i18next';
import UIHelper from 'helpers/UIHelper';
import useBoardDocs from '../useBoardDocs';
import { useEffect } from 'react';
import moment from 'moment';
import FormHelper from '../../../../../helpers/FormHelper';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();

  const { form, handleCreateOrUpdate, shoppingCenters, singleItem, loading } =
    useBoardDocs(false);

  const onFinish = async (values) => {
    const { file, ...rest } = values;
    const data = { ...rest };
    if (file !== true) {
      if (file?.fileList.length > 1) {
        data.file = file?.fileList[1] || null;
      } else {
        data.file = file?.fileList[0] || null;
      }

    }
    if (!data.file && !!singleItem?.id) {
      data.remove_file = true;
      delete data.file;
    }
    await handleCreateOrUpdate(data);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  useEffect(() => {
    if (singleItem?.id) {
      form.setFieldsValue({
        ...singleItem,
        shopping_center_id: singleItem.shopping_center?.id,
        date: moment(singleItem.date),
        // ...singleItem,
      });
    }
  }, [singleItem, form]);

  const title = isNew ? t('Pubblica documento').toUpperCase() : t('MODIFICA PUBBLICAZIONE DOCUMENTO').toUpperCase();
  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            category: '', // [“weekly”, “monthly”, “circulars”, “manuals”, “admin_releases”]
            date: '',
            shopping_center_id: '',
            file: null,
            telegram: false,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          <InfoSection shoppingCenters={shoppingCenters} disabled={title === t('MODIFICA PUBBLICAZIONE DOCUMENTO').toUpperCase()} />
          {!loading && (
            <FileSection
              file={
                singleItem?.id
                  ? {
                      url: singleItem.file_url,
                      name: `${singleItem.title} file`,
                    }
                  : null
              }
            />
          )}
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
